import { Dispatch, memo, SetStateAction, useContext, useEffect } from 'react';
import { useWatch } from 'react-hook-form';

import { useLanguage } from 'assets/languages';
import CampaignFormFieldGroup from '../../../../../campaignFormFieldGroup/campaignFormFieldGroup';
import { CampaignFormContext } from 'pages/campaigns/campaignForm/campaignForm.context';
import TagField from '../../../formFields/tagField/tagField';
import NeedGuidelineRuleField from '../needGuidelineRuleField/needGuidelineRuleField';

interface CoAuthorFieldGroupProps {
  needCoAuthor: boolean;
  setNeedCoAuthor: Dispatch<SetStateAction<boolean>>;
}

const CoAuthorFieldGroup = ({ needCoAuthor, setNeedCoAuthor }: CoAuthorFieldGroupProps) => {
  const language = useLanguage();
  const languageTexts = { ...language.common, ...language.pages.campaigns };
  const { guidelineRuleFormMethods, modal } = useContext(CampaignFormContext);

  const coAuthorValue = useWatch({
    control: guidelineRuleFormMethods.control,
    name: 'CO_AUTHOR.value',
  });

  const onChangeNeedCoAuthor = (value: CoAuthorFieldGroupProps['needCoAuthor']) => {
    setNeedCoAuthor(value);

    if(value === true) {
      modal.showModal({
        maxWidth: 417,
        maxHeight: 304,
        title: languageTexts.create_reels_form_co_author_announcement_title,
        text: languageTexts.create_reels_form_co_author_announcement_desc,
        confirmButtonText: languageTexts.confirm,
        confirm: () => {
          guidelineRuleFormMethods.setValue('CO_AUTHOR', value ? { value: [''] } : null);
        },
      });
  };

    guidelineRuleFormMethods.setValue('CO_AUTHOR', value ? { value: [''] } : null);
  };

  // 공동 작업차 추가가 필요함에 체크되어있고, 공동 작업차가 추가되어있으면 needCoAuthor를 true로 설정
  useEffect(() => {
    if (!needCoAuthor && (coAuthorValue as string[])?.length > 0) {
      setNeedCoAuthor(true);
    }
  }, [coAuthorValue]);

  return (
    <CampaignFormFieldGroup
      wrapperClassName="!gap-[30px]"
      label={`7. ${languageTexts.create_reels_form_co_author_title}`}
      bordered
    >
      <div className="flex flex-col gap-[35px]">
        <NeedGuidelineRuleField
          label={languageTexts.create_reels_form_co_author_title}
          checked={needCoAuthor}
          onClick={onChangeNeedCoAuthor}
        />

        {needCoAuthor && (
          <TagField
            tagFieldName="CO_AUTHOR"
            description={languageTexts.create_reels_form_co_author_desc}
            placeholder={languageTexts.create_reels_form_placeholder_co_author}
            addButtonText={`${languageTexts.add2} +`}
          />
        )}
      </div>
    </CampaignFormFieldGroup>
  );
};

export default memo(CoAuthorFieldGroup);
